import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';
import { useSetupTour } from './SetupTourContext';

/** Completion modal shown after all setup tour steps */
export function SetupTourCompletionModal() {
  const { t } = useTranslation();
  const { status, completeSetupTour } = useSetupTour();

  return (
    <Dialog open={status === 'completed'} onOpenChange={(open) => { if (!open) completeSetupTour(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex justify-center mb-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
              <CheckCircle2 className="h-6 w-6 text-primary" />
            </div>
          </div>
          <DialogTitle className="text-center text-lg">
            {t('tour.setup_complete.title')}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground text-center">
          {t('tour.setup_complete.subtitle')}
        </p>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button className="w-full" onClick={completeSetupTour}>
            {t('tour.setup_complete.done')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
